export default __webpack_public_path__ + "static/media/loginphotoGo.d78063c8.png";